import api from "./api";

const comprobantePagoService = {
    getsComprobantePagoView: async (idComprobante) => {
        const response = await api.get("/Comprobante/GetsComprobantePagoView", { params: { idComprobante } });
        return response.data.data;
    },

    getsComprobantePagoAnuladoView: async () => {
        const response = await api.get("/Comprobante/GetsComprobantePagoAnuladoView");
        return response.data.data;
    },

    // Busqueda de pagos de las pantallas de anulacion y consolidacion. idEstado
    // filtra por estado del pago: 0 todos, 2 Activo, 4 Anulado, 227 Pago
    // Consolidado; serie y numero son los del comprobante del pago.
    getsComprobantePagoSearch: async (filters) => {
        const response = await api.get("/Comprobante/GetsComprobantePagoSearch", { params: filters });
        return response.data.data;
    },

    // Consolida los pagos indicados: pasan a Pago Consolidado y ya no se pueden
    // anular.
    consolidarComprobantePagos: async (pagos, idMotivoConsolidacion = 0) => {
        const response = await api.post("/Comprobante/ConsolidarComprobantePagos", pagos, {
            params: { idMotivoConsolidacion },
        });
        return response.data.data;
    },

    // Desconsolida los pagos indicados: vuelven a estar Activos y se pueden volver
    // a anular o consolidar. Es una accion sensible: si la seguridad exige
    // credenciales, hay que mandar el token devuelto por
    // Seguridad/VerificarCredenciales.
    desconsolidarComprobantePagos: async (pagos, idMotivoDesconsolidacion = 0, token = "") => {
        const response = await api.post("/Comprobante/DesconsolidarComprobantePagos", pagos, {
            params: { idMotivoDesconsolidacion },
            headers: token ? { "X-Autorizacion": token } : {},
        });
        return response.data.data;
    },

    anularComprobantePago: async (idComprobante, numero, idMotivoAnulacion) => {
        const response = await api.post("/Comprobante/AnularComprobantePago", null, {
            params: { idComprobante, numero, idMotivoAnulacion },
        });
        return response.data.data;
    },

    registrarPagosComprobante: async (idComprobante, pagos) => {
        const response = await api.post("/Comprobante/RegistrarPagosComprobante?idComprobante=" + idComprobante, pagos);
        return response.data.data;
    },
};

export default comprobantePagoService;

// Codigo con el que se identifica un pago: la serie y el numero del comprobante
// mas el numero de pago con tres ceros adelante, por ejemplo B001-000001-001.
export const identificadorPago = (pago) => {
    if (!pago || !pago.serie) return "";

    return pago.serie + "-" + String(pago.numeroComprobante).padStart(6, "0")
        + "-" + String(pago.numero).padStart(3, "0");
};